<template>
  <a-list
    :bordered="false"
    :loading="props.index === 1 && props.loading"
    scrollbar
    :max-height="356"
    @reach-bottom="getSelectTableData">
    <template v-if="props.list?.length > 0">
      <p
        v-for="l in props.list"
        :key="l.id"
        class="list_inner"
        :class="{
          diagnosis: props.mode === 'diagnosis',
          discriminate: props.mode === 'discriminate',
          treatment: props.mode === 'treatment',
        }"
        @click="handleSelect(l)"
        @mousedown="handleMousedown">
        <!-- 诊断 -->
        <template v-if="props.mode === 'diagnosis'">
          <span class="label">{{ l.diseaseName }}</span>
          <span class="type">{{ l.diseaseMedicalName }}</span>
          <span class="id">{{ l.diseaseCode }}</span>
        </template>
        <!-- 辨证 -->
        <template v-if="props.mode === 'discriminate'">
          <span class="label">{{ l.discriminateName }}</span>
          <span class="chooseName">{{ l.chooseName }}</span>
          <span class="id">{{ l.discriminateCode }}</span>
        </template>
        <!-- 治法 -->
        <template v-if="props.mode === 'treatment'">
          <span class="label">{{ l.treatmentName }}</span>
          <span class="chooseName">{{ l.chooseName }}</span>
          <span class="id">{{ l.treatmentCode }}</span>
        </template>
      </p>
    </template>
    <template v-else>
      <a-empty></a-empty>
    </template>
  </a-list>
</template>

<script setup>
  const emits = defineEmits(["reachBottom", "select", "down"]);
  const props = defineProps(["index", "loading", "list", "mode"]);
  function getSelectTableData() {
    emits("reachBottom", ...arguments);
  }
  function handleSelect() {
    emits("select", ...arguments);
  }
  function handleMousedown() {
    emits("down", ...arguments);
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/css/mixin.scss";
  .list_inner {
    padding: 12px;
    cursor: pointer;
    @include FontSize_x14;
    display: flex;
    align-items: center;
    & + .list_inner {
      border-top: var(--border_solid_gray);
    }
    &:hover {
      background-color: var(--color_hover);
    }
    .label {
      color: var(--color_black);
      flex: 1;
      width: 0;
      margin-right: 24px;
    }
    .type,
    .id {
      color: var(--color_lightgray02);
      display: block;
      flex-shrink: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: 24px;
    }
    .id {
      width: 120px;
    }
    &.diagnosis {
      .type {
        width: 160px;
      }
    }
    &.discriminate,
    &.treatment {
      .chooseName {
        width: 300px;
      }
    }
  }
  .arco-empty {
    padding: 24px 0;
    flex-direction: column;
  }
</style>
